/*
  makeApiCall.js
*/

/**
 * Returns an API url, using a root URL and a pathname.
 * Mainly used to join two URLs while removing double slashes.
 */
function getApiUrl(rootUrl, path) {

  rootUrl = rootUrl || '';
  path = path || '';

  if (rootUrl.endsWith('/')) {
    rootUrl = rootUrl.slice(0, -1);
  }

  if (path.startsWith('/')) {
    path = path.slice(1);
  }
  
  return `${rootUrl}/${path}`;

}

/**
 * Makes an API call to the botech API.
 */
export default function makeApiCall(method = 'GET', path = '/', bodyOrSearch = null) {

  // Check for API url.
  const apiUrl = getApiUrl(process.env.REACT_APP_API_URL, path);

  // Get headers. We always assume the response is JSON for now.
  const headers = {
    'Accept': 'application/json',
  };

  // Get a JSON body, or append search params, according to method.
  let body = null;
  if (bodyOrSearch) {
    if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
      body = JSON.stringify(bodyOrSearch);
      headers['Content-Type'] = 'application/json';
    } else {
      const searchStr = String(new URLSearchParams(bodyOrSearch));
      if (searchStr) {
        apiUrl += `?${searchStr}`;
      }
    }
  }

  // Abort functionality.
  const controller = typeof AbortController === 'function' ? new AbortController() : null;
  const signal = controller ? controller.signal : null;
  function abort() {
    if (controller) {
      controller.abort();
    }
  }

  // Call the API.
  const promise = fetch(apiUrl, {
    method,
    headers,
    body,
    mode: 'cors',
    signal,
  }).then(res => {
    if (res.status < 200 || res.status >= 300) {
      return res.text().catch(err => '').then(text => {
        throw new Error(text || res.statusText);
      });
    } else {
      return res.json();
    }
  });

  // Add a catch to the promise separately in case it errors immediately
  // due to an invalid argument or similar, which may error the react app.
  promise.catch(err => {
    // Ignore.
  });

  // Return promise with ability to abort.
  return { promise, abort };

}
